/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { type HttpResponse, type Rest, DownloadService as DmDownloadService, HttpService, I18nService, ToastService } from '@dm/core';

@Injectable({
    providedIn: 'root',
})
export class DownloadService {
    iframeLength = 0;

    constructor(
        private httpService: HttpService,
        private toastService: ToastService,
        private i18nService: I18nService,
        private downloadService: DmDownloadService,
    ) { }

    downloadFile(rest: Rest, errorCallback?: (err: any) => any): void {
        const url = rest.url + (rest.url.includes('?') ? '&' : '?') + 't=' + Date.now();

        const iframe = document.createElement('iframe');
        iframe.setAttribute('id', 'downloadFileIframe' + this.iframeLength);
        iframe.setAttribute('name', 'downloadFileIframe' + this.iframeLength);

        this.iframeLength++;

        iframe.setAttribute('style', 'display: none');

        // 只有下载失败才会触发onload事件
        const onError = (): void => {
            iframe.onload = null;

            const callback = typeof errorCallback === 'function' ?
                errorCallback :
                (): void => {};

            const response = iframe.contentDocument.body.innerText;
            if (response) {
                let res;
                try {
                    res = JSON.parse(response);
                } catch (e) {
                    // 异常处理
                }
                if (res && (res.result || res.error)) {
                    let responseNew: HttpResponse;
                    if (rest.type === 'IBASE') {
                        responseNew = {
                            ...res,
                            result: {
                                code: res.error.code,
                                description: res.error.description,
                                suggestion: res.error.suggestion,
                            },
                            data: res.data,
                            response,
                        };
                        delete responseNew.error;
                    } else if (rest.type === 'V2') {
                        responseNew = {
                            ...res,
                            result: {
                                code: res.result.code,
                                description: res.result.description,
                                suggestion: res.result.suggestion,
                            },
                            data: res.data,
                            response,
                        };
                    }

                    this.httpService.handleException(rest, responseNew);
                    callback(responseNew);
                } else {
                    this.toastService.error(this.i18nService.get('download_failed'));
                    callback(response);
                }
            }
        };

        document.body.append(iframe);
        iframe.onload = onError;
        iframe.setAttribute('src', url);
    }

    downloadWithBlob(blob: Blob, fileName: string): void {
        this.downloadService.downloadWithBlob(blob, fileName);
    }
}
